<template>
  <div>
    <ul class="billing__lessons b_lessons" v-if="items.length > 0" >
      <lesson v-for="lesson in items" :lesson="lesson" :key="lesson.date"></lesson>
    </ul>
    <div v-else>Уроков не найдено</div>
  </div>
</template>

<script>
import lesson from "./lesson";

export default {
  name: "lessons",
  components: { lesson },
  data() {
    return {}
  },
  props: {
    items: {
      default: []
    }
  },
  methods: {}
}
</script>